import React from "react";

const reviews = [
  {
    name: "Marko P.",
    text: "Predivno iskustvo! Kuća je savršena, okružena prirodom. Definitivno se vraćamo!",
  },
  {
    name: "Ivana H.",
    text: "Vikend je bio opuštajući, sve je bilo izvanredno. Odlična lokacija i mir.",
  },
  {
    name: "Petar N.",
    text: "Sve pohvale! Kuća je prostrana, uredna i ima sve što je potrebno za ugodan odmor.",
  },
];

const HomeReviews = () => {
  return (
    <div className="reviews">
      <h2>Što kažu naši gosti:</h2>
      <div className="reviews-grid">
        {reviews.map((review, index) => (
          <div key={index} className="review-card">
            <h3 className="review-name">{review.name}</h3>
            <div className="review-text">
              <i className="fi fi-rs-quote-right"></i>
              <p>{review.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeReviews;
